export default {
  name: "Contacts",
  path: "/contact-us",
  component: () => import("@/views/Contacts")
};
